import * as mutationTypes from './mutation-types'
import windsorUrls from '../../static/windsor-urls'

const initialState = () => ({
    found: true,
    routeNames: [],
    windsorUrls
})

export default (namespace) => ({
    namespaced: true,
    state: initialState(),
    getters: {
        found: state => state.found,
        namespace: () => namespace,
        routeNames: state => state.routeNames,
        windsorUrls: () => windsorUrls
    },
    actions: {
        resetApp: ({commit}) => commit(mutationTypes.RESET_APP),
        setFound: ({commit}, found = true) => commit(mutationTypes.SET_FOUND, found),
        setRouteNames: ({commit}, routeNames) => commit(mutationTypes.SET_ROUTE_NAMES, routeNames)
    },
    mutations: {
        [mutationTypes.RESET_APP]: state => Object.assign(state, initialState()),
        [mutationTypes.SET_FOUND]: (state, found) => state.found = found,
        [mutationTypes.SET_ROUTE_NAMES]: (state, routeNames) => state.routeNames = routeNames
    }
})
